import Icons from "./icon"

export type { IconProps } from "./icon"
export { isIconName } from "../utils/propTypes"
export default Icons
